<template>
  <div id="app">
    <!--    <Header></Header>-->
    <router-view />
    <!--    <Footer></Footer>-->
    <Toast v-model="toastValue" :error="errorToast"></Toast>
  </div>
</template>

<script>
// import Header from "@/components/Header/Header";
// import Footer from "@/components/Footer/Footer";
import DefaultParams from "@/utils/defalut_params.js";
import Toast from "@/components/Toast/Toast";
import evevt_bus from "@/utils/evevt_bus.js";
export default {
  components: {
    // Header,
    // Footer,
    Toast
  },
  data() {
    return {
      toastValue: "",
      errorToast: false
    };
  },
  created() {
    DefaultParams.init();
    evevt_bus.$on("show_toast", ({ value, error }) => {
      this.toastValue = value;
      this.errorToast = error;
    });
  }
};
</script>
